module.exports = __webpack_public_path__ + "img/e.f543e96c.jpg";